import globalStyles from "../../../../App.module.scss";
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import {dracula} from 'react-syntax-highlighter/dist/esm/styles/prism'

export default function MountRemoteSharesCifs() {

    let data = `#!/usr/bin/env bash

IFS=,

createdirectories_and_mount() {
  for folder in $REMOTE_FOLDERS; do
    local_path="$MOUNT_ROOT/$folder"
    # Create directories to mount remote shared folders
    if [ ! -d "$local_path" ]; then
      sudo mkdir $local_path
    fi

    # Mount share
    sudo mount -t cifs //$REMOTE_SERVER_IP/$folder $local_path -o uid=$USER,gid=$USER,credentials=$SMBPASSWD,rw,iocharset=utf8,file_mode=0744,dir_mode=0755
  done
}

MOUNT_ROOT=/home/$USER
REMOTE_FOLDERS="folder1,folder2,folder3"
REMOTE_SERVER_IP=192.168.1.88
SMBPASSWD=/home/$USER/.smbpasswd

createdirectories_and_mount`;

    return (
        <div className={globalStyles.article}>
            <h1>Automate remote shares mount using CIFS/Samba</h1>
            <p>If shares need to be mounted on a more permanent way, it is better to use /etc/fstab. This script is
                useful when
                shares are not online all the time. Inaccessible shares mounted through /etc/fstab delay system boot and
                shutdown.</p>
            <h3>Requirements</h3>
            <ul>
                <li>cifs-utils</li>
                <li>Server running samba with shares (enable SMB3)</li>
                <li>User account/password to access the shared folders</li>
            </ul>
            <p>It works well with Synology nas. I also tried with Ubuntu server samba shares using
                <a style={{textDecoration:"none"}} href={'https://en.wikipedia.org/wiki/Pluggable_authentication_module'}>
                    <abbr style={{textDecoration:"none",cursor:"pointer"}} title='Plugable Authentication Modules'> PAM</abbr>
                </a> authentication</p>

            <h3>Credentials file</h3>
            <p>Example file <i className={globalStyles.code}><b>~/.smbpasswd</b></i>:</p>
            <pre className={globalStyles.code} >
                <code>{`user=username`} <br/>{`password=password1`}</code>
            </pre>
            <h3>Script</h3>
            <p>This script will mount the remote directories in the folder specified by "MOUNT_ROOT" and will create a
                directory for each share if it doesn't exists.</p>
            <SyntaxHighlighter
                children={data}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
        </div>
    )
}